import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import IconLink from '@/global/components/Button/IconLink'
import { cn } from '@/lib/utils'
import { Button } from '@/global/components/Button'
import PreviewAnexo, { isImage } from 'global/components/Anexo'
import Dialog from 'global/guides/Dialog'
import { DownloadIcon, PaperclipIcon } from 'lucide-react'
import React, { useState } from 'react'
import { uploads } from 'service/api/endpoints/uploads'

const VisualizarAnexoModal: React.FC<GridCellParams> = ({ value }) => {
    const [open, setOpen] = useState(false)

    if (!value) return null
    const source = `${uploads.URI}/${value}`

    return (
        <>
            <Button onClick={() => setOpen(true)} endIcon={<PaperclipIcon />}>
                Exibir
            </Button>
            <Dialog.Root open={open} onClose={() => setOpen(false)}>
                <Dialog.Title
                    endAdornment={
                        <IconLink title="Baixar anexo" href={source}>
                            <DownloadIcon />
                        </IconLink>
                    }
                >
                    <span className="text-base">Visualizar anexo</span>
                </Dialog.Title>
                <Dialog.Content className="flex! max-h-full overflow-y-clip">
                    <div
                        className={cn(
                            'm-auto w-full max-h-full overflow-y-clip',
                            isImage(value.split('.').pop()!)
                                ? 'max-w-[22rem]'
                                : 'max-w-[40rem]',
                        )}
                    >
                        <PreviewAnexo
                            source={source}
                            ext={value.split('.').pop()!}
                        />
                    </div>
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                </Dialog.Actions>
            </Dialog.Root>
        </>
    )
}

export default VisualizarAnexoModal
